"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base = 100;
exports.SQRT_5 = Math.sqrt(5);
exports.PHI = (exports.SQRT_5 + 1) / 2;
exports.GLD10 = base / exports.PHI;
exports.GLD9 = base - exports.GLD10;
exports.GLD8 = exports.GLD9 / exports.PHI;
exports.GLD7 = exports.GLD9 - exports.GLD8;
exports.GLD6 = exports.GLD7 / exports.PHI;
exports.GLD5 = exports.GLD7 - exports.GLD6;
exports.GLD4 = exports.GLD5 / exports.PHI;
exports.GLD3 = exports.GLD5 - exports.GLD4;
exports.GLD2 = exports.GLD3 / exports.PHI;
exports.GLD1 = exports.GLD3 - exports.GLD2;
exports.DEFAULT_MODULAR_SCALE_BASE = 1;
exports.DEFAULT_MODULAR_SCALE_RATIO = exports.PHI;
exports.DEFAULT_MODULAR_SCALE_UNIT = 'rem';
exports.DEFAULT_MODULAR_SCALE_ROOT_BASE = '16px';
//# sourceMappingURL=ModularScaleDefaults.js.map